<template>
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog" style="max-width:640px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h2>Duplicar QTS Semanal</h2>
                    <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
                        </span>
                    </div>
                </div>
                <div class="modal-body scroll-y m-5">
                    <p class="text-muted">
                        Cria um novo QTS (RASCUNHO) copiando apenas as <b>disciplinas configuradas</b>
                        (com suas restrições). Não copia dias nem alocações.
                    </p>
                    <div class="row g-5">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="form-check-label">Descrição:</label>
                                <input type="text" class="form-control" v-model="descricao" />
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label class="form-check-label">Novo início:</label>
                                <input type="date" class="form-control" v-model="dataInicio" />
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label class="form-check-label">Novo fim:</label>
                                <input type="date" class="form-control" v-model="dataFim" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <BotaoSalvar @click="salvar" :processando="processando" titulo="Duplicar"></BotaoSalvar>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
import { Options, Vue } from "vue-class-component";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import SiteUtils from '@/assets/ts/aplicacao/site';
import $ from "jquery"
import { Prop, Watch } from 'vue-property-decorator';
import QtsSemanalService from "@/service/v1/sigap/QtsSemanalService";

@Options({
    name: "QtsSemanalDuplicar",
    components: { BotaoSalvar },
    emits: ['qts-duplicado'],
})
export default class QtsSemanalDuplicar extends Vue {

    @Prop() readonly modal!: any
    @Prop() readonly perfis!: any
    @Prop() readonly modelo!: any

    public service = new QtsSemanalService();

    public processando = false;
    public descricao: any = null;
    public dataInicio = '';
    public dataFim = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    // Ao selecionar um QTS para duplicar, prepara a descrição "(cópia)" e zera o período (deve ser informado).
    @Watch('modelo')
    public modeloAlterado() {
        if (!this.modelo) return;
        this.descricao = this.modelo.descricao ? `${this.modelo.descricao} (cópia)` : '';
        this.dataInicio = '';
        this.dataFim = '';
    }

    public salvar() {
        if (this.processando || !this.hasPermissao || !this.modelo?.id) return;
        if (!this.dataInicio || !this.dataFim) {
            SiteUtils.toastErro('Erro!', 'Informe o novo período (início e fim).');
            return;
        }
        if (this.dataInicio > this.dataFim) {
            SiteUtils.toastErro('Erro!', 'A data início deve ser menor ou igual à data fim.');
            return;
        }
        this.processando = true;
        const dados = { inicio: this.dataInicio, fim: this.dataFim, descricao: this.descricao || null };
        setTimeout(() => {
            this.service.duplicar(this.modelo.id, dados)
                .then(response => {
                    SiteUtils.toastSucesso('QTS duplicado com sucesso!', response?.message);
                    $("[data-bs-dismiss='modal']").trigger({ type: "click" });
                    this.processando = false;
                    this.$emit('qts-duplicado', response?.id);
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Erro!', error?.data?.message);
                });
        }, 100);
    }
}
</script>
